// ./utils/confirm/confirm.provider.tsx
import { createContext, type ReactNode, useCallback, useMemo, useState } from "react";

import { Confirm } from "./confirm";
import { ConfirmContext, ConfirmOptions, Nullable } from "../common";

export const ConfirmCtx = createContext<Nullable<ConfirmContext>>(null);

interface Props {
    children: ReactNode;
}

export function ConfirmProvider({ children }: Props) {
    const [confirm, setConfirm] = useState<Nullable<ConfirmOptions>>(null);

    const [open, toggle] = useState(false);

    const show = useCallback(
        (confirmOptions: Nullable<ConfirmOptions>) => {
            setConfirm(confirmOptions);
            toggle(true);
        },
        [toggle]
    );

    const onConfirm = () => {
        for (let key of Object.keys(localStorage)) {
            if (key.includes("Decision Point") ||key.includes("unsavedChallenge")) {
                localStorage.removeItem(key);
            }
        }
        confirm?.onConfirm?.();
        toggle(false);
    };

    const onCancel = () => {
        confirm?.onCancel?.();
        toggle(false);
    };

    const value = useMemo(() => ({ show }), [show]);

    return (
        <ConfirmCtx.Provider value={value}>
            <Confirm type="warning" {...confirm} onCancel={onCancel} onConfirm={onConfirm} open={open} />
            {children}
        </ConfirmCtx.Provider>
    );
}
